import { EditOutlined, RedoOutlined, CalendarOutlined, EyeOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Button, Space, Popover, Tag, Modal, Pagination } from 'antd';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../../../config';
import { useSelector } from 'react-redux';
import moment from 'moment';
import CountUp from 'react-countup';
import PageDetails from '../../PageDetails/PageDetails';
import VarianteEdit from '../varianteEdit/VarianteEdit';
import canSeeFinance from '../../../utils/canSeeFinance';
import {
  NdoePage, NdoePageHeader, NdoeActionButton,
  NdoeResponsiveTable, NdoeDataCard, NdoeStatusBadge, NdoeStatCard, NdoeStats,
  NdoeImage, NdoeRecherche, filtreTexte, optionsDe, compterActifs,
} from '../../../components/ndoe';

const ListeVariante = () => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [produit, setProduit] = useState([]);
    const [idVariant, setvariant] = useState({});
    const [opensVariant, setOpensVariant] = useState(false);
    // Facettes de la recherche unifiee (remplacent le panneau VarianteSelect).
    const [marque, setMarque] = useState(undefined);
    const [categorie, setCategorie] = useState(undefined);
    const [openss, setOpenss] = useState(false);
    const user = useSelector((state) => state.user?.currentUser);
    const showFinance = canSeeFinance(user);
    const [produitTotalAchats, setProduitTotalAchats] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [pagination, setPagination] = useState({
      current: 1,
      pageSize: 15,
    });
    const [totalItems, setTotalItems] = useState('');

      // NOTE (modernisation UI, 2026-07-09) : l'action "Supprimer" a été retirée.
      // Elle appelait DELETE /api/livraison/livraisonDeleteDetail/:id avec
      // record.id_detail_livraison — champ absent des lignes de variante : la
      // suppression ciblait la mauvaise entité (un détail de livraison) et était
      // donc cassée. Une vraie suppression de variante (DELETE /api/produit/
      // varianteProduit/:id) a des effets sur le stock ; à réintroduire seulement
      // après validation métier (cf. dépréciations 410 du 08/07).

      const showModalPhone = (e) => {
        setOpensVariant(true);
        setvariant(e)
      };

      const handleEdit = (id) => {
        setOpenss(!openss)
        setvariant(id)
      }

      const Rafraichir = () => {
        fetchData(currentPage, pageSize);   // refetch au lieu de recharger toute la page
      }

      const baseColumns = [
          { title: '#',
            dataIndex: 'id',
            key: 'id',
            render: (text, record, index) => {
              const size = pagination.pageSize || 15;
              const pageIndex = pagination.current || 1;
              return (pageIndex - 1) * size + index + 1;
            }
          },
          {
            title: 'image',
            dataIndex: 'img',
            key: 'img',
            render: (text, record) => (
              <NdoeImage src={record.img} alt={record.nom_produit || 'Variante'} size="lg" />
            ),
          },
        {
            title: 'Description',
            dataIndex: 'nom_produit',
            key: 'nom_produit',
            render: (text) => (
              <Tag color='cyan'>{text}</Tag>
            )
        },
        {
            title: 'Categorie',
            dataIndex: 'nom_categorie',
            key: 'nom_categorie',
            render: (text) => (
              <Tag color='cyan'>{text}</Tag>
            )
        },
        {
          title: 'Marque',
          dataIndex: 'nom_marque',
          key: 'nom_marque',
          render: (text) => (
            <Tag color={"green"}>
              {text}
            </Tag>
          )
        },
        {
          title: 'Pointure',
          dataIndex: 'taille',
          key: 'taille',
          render: (text) => (
            <Tag color={"blue"}>
              {text}
            </Tag>
          )
        },
        {
          title: "Date d'entrée",
          dataIndex: 'created_at',
          key: 'created_at',
          sorter: (a, b) => moment(a.created_at).unix() - moment(b.created_at).unix(),
          sortDirections: ['descend', 'ascend'],
            render: (text) => (
              <span>
                <Tag color={'blue'} icon={<CalendarOutlined />}>
                  {moment(text).format('DD-MM-yyyy')}
                </Tag>
              </span>
            ),
        },
        {
          title: '# variante',
          dataIndex: 'code_variant',
          key: 'code_variant',
          render: (text) => (
            <Tag color={"orange"}>
              {text}
            </Tag>
          )
        },
        // MT total (finance) — visible admin uniquement (filtré plus bas).
        {
          title: 'MT total',
          dataIndex: 'total',
          key: 'total',
          finance: true,
          render: (text) => (
            <Tag color={"blue"}>
              {`${text} $`}
            </Tag>
          )
        },
        {
          title: 'Qté en stock',
          dataIndex: 'total_stock',
          key: 'total_stock',
          sorter: (a, b) => a.total_stock - b.total_stock,
          sortDirections: ['descend', 'ascend'],
          render: (total_stock) => (
            <Tag color={total_stock > 0 ? 'green' : 'red'}>{total_stock}</Tag>
          ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
              <Space size="middle">
                  <Popover title="Modifier" trigger="hover">
                    <Button icon={<EditOutlined />} style={{ color: 'green' }} onClick={()=> handleEdit(record.id_varianteProduit)} />
                  </Popover>
                 <Popover title="Voir les détails" trigger="hover">
                  <Link onClick={()=>showModalPhone(record.id_varianteProduit)} >
                    <Button icon={<EyeOutlined />} style={{ color: 'blue' }} />
                  </Link>
                </Popover>
              </Space>
            ),
          },
      ];

      // Retire les colonnes finance pour les rôles non autorisés.
      const columns = baseColumns.filter((c) => !c.finance || showFinance);

      const fetchData = async (page = currentPage, size = pageSize) => {
          try {
            const { data } = await axios.get(`${DOMAIN}/api/produit/listeVarianteProduit?page=${page}&pageSize=${size}`);
            setData(data?.data);
            setTotalItems(data?.totalItems);
            setLoading(false)
          } catch (error) {
            console.log(error);
            setLoading(false)
          }
        };

      useEffect(() => {
        fetchData(currentPage, pageSize);
      }, [currentPage, pageSize]);

      useEffect(()=>{
        const fetchCount = async ()=> {
            try{
                const res = await axios.get(`${DOMAIN}/api/produit/produitCount`);
                setProduit(res.data)
              }catch(error){
                console.log(error)
              };
        }
        fetchCount()
     }, [DOMAIN])

     useEffect(() => {
      const fetchAchats = async () => {
        try {
          const { data } = await axios.get(`${DOMAIN}/api/rapport/achatsTotal/total`);
          setProduitTotalAchats(data[0]?.montant_total_achats);
        } catch (error) {
          console.log(error);
        }
      };
      fetchAchats();
    }, [DOMAIN]);

    // Corrige le bug : la pagination est désormais réellement rebranchée sur le
    // rechargement des données (avant, changer de page ne rechargeait rien).
    const handleTableChange = (paginationArg) => {
      setCurrentPage(paginationArg.current);
      setPageSize(paginationArg.pageSize);

      setPagination({
        current: paginationArg.current,
        pageSize: paginationArg.pageSize,
      });
      fetchData(paginationArg.current, paginationArg.pageSize);
    };

    // Zone libre : plusieurs mots = ET. La POINTURE y entre sous ses DEUX
    // formes — « 38 » et « P38 » : c'est « P38 » qui s'affiche, mais « 38 »
    // qu'on a en tête (même piège que sur les ventes).
    const filteredData = (data || [])
      .filter(filtreTexte(searchValue, [
        'nom_categorie', 'nom_marque', 'nom_produit', 'code_variant', 'code_article',
        'description', 'nom_couleur',
        (v) => v.taille, (v) => (v.taille ? `P${v.taille}` : null),
      ]))
      .filter((v) => !marque || String(v.nom_marque) === marque)
      .filter((v) => !categorie || String(v.nom_categorie) === categorie);

    // --- Carte variante (mobile) ---
    const renderVarianteCard = (record) => {
      const inStock = Number(record.total_stock) > 0;
      const metrics = [
        { value: record.total_stock, label: 'qté' },
        { value: record.code_variant, label: 'réf' },
        { value: record.taille, label: 'pointure' },
      ];
      if (showFinance) metrics.push({ value: `${record.total} $`, label: 'montant' });

      return (
        <NdoeDataCard
          media={<NdoeImage src={record.img} alt={record.nom_produit || 'Variante'} size="lg" />}
          title={record.nom_produit}
          subtitle={[record.nom_categorie, record.nom_marque].filter(Boolean).join(' · ')}
          badge={<NdoeStatusBadge kind="custom" tone={inStock ? 'ok' : 'danger'} label={inStock ? `${record.total_stock} en stock` : 'Rupture'} />}
          metrics={metrics}
          onClick={() => showModalPhone(record.id_varianteProduit)}
          actions={[
            <NdoeActionButton key="e" size="sm" variant="ink" icon={<EditOutlined />} onClick={() => handleEdit(record.id_varianteProduit)}>Modifier</NdoeActionButton>,
            <NdoeActionButton key="v" size="sm" variant="secondary" icon={<EyeOutlined />} onClick={() => showModalPhone(record.id_varianteProduit)}>Détails</NdoeActionButton>,
          ]}
        />
      );
    };

  return (
    <NdoePage>
      <NdoePageHeader
        eyebrow="Catalogue"
        title="Stock des chaussures"
        subtitle="Gérer vos déclinaisons et leur quantité en stock"
        actions={
          <NdoeActionButton variant="secondary" icon={<RedoOutlined />} onClick={Rafraichir}>
            Actualiser
          </NdoeActionButton>
        }
      />

      <NdoeStats>
        <NdoeStatCard label="Articles en stock" value={<CountUp end={produit[0]?.total || 0} />} />
        {showFinance && (
          <NdoeStatCard gold label="Montant total" value={<><CountUp end={produitTotalAchats || 0} /> $</>} />
        )}
      </NdoeStats>

      {/* L'ancien « Filtres avancés » (VarianteSelect) devient des facettes
          construites depuis les variantes déjà chargées. */}
      <NdoeRecherche
        q={searchValue}
        onQ={setSearchValue}
        placeholder="Produit, référence, code, marque, catégorie, couleur, pointure (38 ou P38)…"
        facettes={[
          { cle: 'marque', placeholder: 'Marque', options: optionsDe(data, 'nom_marque'), valeur: marque, onChange: setMarque, largeur: 160 },
          { cle: 'categorie', placeholder: 'Catégorie', options: optionsDe(data, 'nom_categorie'), valeur: categorie, onChange: setCategorie, largeur: 160 },
        ]}
        actifs={compterActifs(searchValue, marque, categorie)}
        onEffacer={() => { setSearchValue(''); setMarque(undefined); setCategorie(undefined); }}
        resume={`${filteredData.length} sur ${data?.length || 0} variante${(data?.length || 0) > 1 ? 's' : ''}`}
      />

      <NdoeResponsiveTable
        data={filteredData}
        columns={columns}
        rowKey="id_varianteProduit"
        loading={loading}
        renderCard={renderVarianteCard}
        scroll={{ x: 'max-content' }}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: Number(totalItems) || 0,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100', '200', '300', '400', '500', '600'],
        }}
        onChange={handleTableChange}
        empty={{ icon: '👟', title: 'Aucune variante', text: 'Ajustez la recherche ou les filtres.' }}
        mobilePager={
          <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center' }}>
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={Number(totalItems) || 0}
              showSizeChanger={false}
              onChange={(p, s) => handleTableChange({ current: p, pageSize: s })}
            />
          </div>
        }
      />

      <Modal
        title=""
        centered
        open={opensVariant}
        onCancel={() => setOpensVariant(false)}
        width={1100}
        footer={[]}
      >
        <PageDetails id={idVariant} />
      </Modal>

      <Modal
        title=""
        centered
        open={openss}
        onCancel={() => setOpenss(false)}
        width={500}
        footer={[]}
      >
        <VarianteEdit id={idVariant} closeModal={() => setOpenss(!openss)} fetchData={fetchData} />
      </Modal>
    </NdoePage>
  )
}

export default ListeVariante
